import AxiosInstance from "@/config/AxiosInstance";
import { API_BASE_URL } from "@/config/appConfig";

export interface BrandResourceSettingsResponse {
  // Keys getting used
  has_brand_resource: boolean;

  // Keys not getting used
}

export const settingsService = { checkResourceCenter };

function checkResourceCenter(brandId: number | string) {
  return AxiosInstance.get(
    `${API_BASE_URL}/brand/brandResouceChecker/${brandId}`
  );
}
